// Form5 Constants

export const DEFAULT_MESSAGES = {
  CONFIG_NOT_FOUND: "Configuration not found",
  VALIDATION_ERROR_TITLE: "Validation Error",
  VALIDATION_ERROR_DESCRIPTION: "Please fix the errors before saving",
  CREATE_NOT_CONFIGURED: "Create method not configured",
  UPDATE_NOT_CONFIGURED: "Update method not configured",
  DELETE_NOT_CONFIGURED: "Delete method not configured",
  ID_REQUIRED: "ID is required for update",
  SETTINGS_ID_REQUIRED: "Settings ID is required. Please select a variant first.",
  RESPONSE_ID_ERROR: "Failed to get ID from response",
  SUCCESS_CREATE: "Created successfully",
  SUCCESS_UPDATE: "Updated successfully",
  SUCCESS_DELETE: "Deleted successfully",
  ERROR_SAVE: "Failed to save",
  ERROR_DELETE: "Failed to delete",
} as const;

export const DEFAULT_UI = {
  TREE_ICON: "📚",
  TREE_TITLE: "Items",
  EMPTY_MESSAGE: "No items yet. Add your first one below.",
  NEW_BUTTON: "New",
  EDIT_LABEL: "✏️ Edit Item",
  ADD_NEW_LABEL: "➕ Add New Item",
  UPDATE_BUTTON: "Update",
  SAVE_BUTTON: "Add Item",
  CANCEL_BUTTON: "Cancel",
} as const;

export const DEFAULT_FIELDS = {
  PRIMARY: "name",
  SECONDARY: "value",
} as const;

